import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { BrandStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

interface Props extends WidgetProps {}

export interface BrandDetailsNameStyles {
    container?: InjectableCss;
    heading?: TypographyProps;
}

export const logoStyles: BrandDetailsNameStyles = {
    heading: {
        variant: "h1",
        css: css`
            overflow-wrap: break-word;
            word-wrap: break-word;
        `,
    },
    container: {
        css: css`
            width: 100%;
            margin: 15px;
        `,
    },
};

const styles = logoStyles;

const BrandDetailsName: FC<Props> = () => {
    const { value: brand } = useContext(BrandStateContext);
    if (!brand) {
        return null;
    }
    return (
        <StyledWrapper {...styles.container} data-test-selector="brandName">
            <Typography data-test-selector="brandNameHeading" {...styles.heading}>
                {brand.name}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: BrandDetailsName,
    definition: {
        group: "Brand Details",
        icon: "diamond",
        displayName: "Brand Name",
        allowedContexts: ["BrandDetailsPage"],
    },
};

export default widgetModule;
